import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params, Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectAllCarImagesFolders, selectAllSearchedJobs, selectAllSearchedJobsPreviewTotalCount, selectJobCriteria, selectSearchFetchingResults, selectDealerProfile } from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { JobCriteria } from 'src/app/public/keep/models/job-criteria.model';
import { Job } from 'src/app/public/keep/models/job.model';


@Component({
    selector: 'app-job-search',
    templateUrl: './job-search.component.html',
    styleUrls: ['./job-search.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JobSearchComponent implements OnInit {

  objectSource: ObjectSource = ObjectSource.SEARCH

  @Input() carId: string = ""

  currentDealer$: Observable<Dealer>;
  
  previewTotalCount$: Observable<number>;
  searchCriteria$: Observable<JobCriteria>;

  fetchingResults$: Observable<boolean>;

  jobResults$: Observable<Job[]>;
  jobResults: Job[] = [];

  //count$: Observable<number>;

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;

  jobCriteria: JobCriteria = new JobCriteria();
  pageNumber: number = 0;
  pageSize: number = AppConstants.PAGE_SIZE_DEFAULT;
  pageNumbers: number [] = [ 1 ];

  totalItems: number = 0;
  pageSizeOptions = AppConstants.PAGE_SIZE_OPTIONS;

  jobsFetched: boolean = false;
  parameters?: Params;

  constructor(

    private store: Store, 
    private route: ActivatedRoute,
    router: Router
    ) {
      
      this.currentDealer$ = store.select(selectDealerProfile);

      this.searchCriteria$ = store.select(selectJobCriteria);
      this.previewTotalCount$ = store.select(selectAllSearchedJobsPreviewTotalCount);

      this.fetchingResults$ = store.select(selectSearchFetchingResults);
      this.jobResults$ = store.select(selectAllSearchedJobs);
      //this.count$ = store.select(selectAllSearchedCarsCount);

      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);

      this.searchCriteria$.subscribe(criteria => {
        this.jobCriteria = criteria;
        this.pageSize = this.jobCriteria.pageSize;
        this.pageNumbers = Array(Math.ceil(this.totalItems/this.jobCriteria.pageSize)).fill(0).map((x,i)=>i);
      });

      route.queryParams.subscribe(params => {

        //let temp = JSON.parse(JSON.stringify(params));
        console.log("params = "+JSON.stringify(params));
        this.parameters = params;

        //let temp = Object.assign(new JobCriteria(), params);
        let crt: JobCriteria = new JobCriteria();
        AppFunctions.replaceValues(crt, params);

        console.log("criteria 1= "+JSON.stringify(crt));

        this.store.dispatch(SearchActions.jobCriteriaSubmit({jobCriteria: crt}));

      });

    }

    ngOnInit() {

      this.previewTotalCount$.subscribe(total => {
        this.totalItems = total;
        //this.pageNumbers = Array(Math.ceil(this.totalItems/this.jobCriteria.pageSize)).fill(0).map((x,i)=>i);
      });

      if(!this.jobsFetched){
        
        //let crt: JobCriteria = JSON.parse(JSON.stringify(this.jobCriteria));
        let crt: JobCriteria = new JobCriteria();
        AppFunctions.replaceValues(crt, this.parameters);

        console.log("criteria 22 = "+JSON.stringify(crt));
        this.store.dispatch(SearchActions.jobCriteriaSubmit({jobCriteria: crt}));
        this.jobsFetched = true;

      } 

      this.jobResults$.subscribe(
        (res: Job[]) =>  {
          this.jobResults = res.map(c => Object.assign(new Job(), c));
        }
      );
  }

  loadPreviousPage(){
    if(this.pageNumber > 0){
      this.pageNumber --;
      this.dispatchEvent();
    }
    
  }

  loadNextPage(){
    if(this.pageNumber < this.totalItems/this.pageSize - 1){
      this.pageNumber ++;
      this.dispatchEvent();
    } 
  }

  loadPage(pgNum: number){

      this.pageNumber = pgNum;
      this.dispatchEvent();
    
  }

  updatePageSize(){
    this.pageNumber = 0;
    this.dispatchEvent();
  }
  
  dispatchEvent(){

    let crt = JSON.parse(JSON.stringify(this.jobCriteria));
    crt.pageSize = this.pageSize;
    crt.pageNumber = this.pageNumber;
    this.store.dispatch(SearchActions.jobCriteriaSubmit({jobCriteria: crt}));
  }
  
}

